// Appends a query param to a URL regardless of whether it already has one
// (`?`) or not, without disturbing any params already present.
export function appendQueryParam(url: string, key: string, value: string): string {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${key}=${encodeURIComponent(value)}`;
}
